import { useTranslation } from "react-i18next";
import type { SegmentedControlOption } from "src/common/components/SegmentedControl/SegmentedControl";

export type EnduserCompareEntityType = "parcours" | "modules" | "groupes_parcours";

export const useEnduserRankingTabOptions =
  (): SegmentedControlOption<EnduserCompareEntityType>[] => {
    const { t } = useTranslation();

    return [
      { value: "parcours", label: t("enduserStats.comparateur.subTabs.parcours") },
      { value: "modules", label: t("enduserStats.comparateur.subTabs.modules") },
      { value: "groupes_parcours", label: t("enduserStats.comparateur.subTabs.groupesParcours") },
    ];
  };
